import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { publicAssets } from '@utils/url.utils';
import { CantFindYourDreamCarStyled } from '../CantFindYourDreamCarStyled';
export const CantFindYourDreamCarStyledOVGB = styled(CantFindYourDreamCarStyled)`
    .img {
        background-image: url('${publicAssets('/images/cantFindYourDreamCarVx_mob.png')}');

        @media (min-width: ${breakpoints.sm}px) {
            background-image: url('${publicAssets('/images/cantFindYourDreamCarVx.png')}');
        }
    }
`;
